'use client';

import {
  BoldHeadingQuinaryDynamic,
  SlideContent,
} from '@/features/news-managment/styles';
import { Box } from '@/shared/ui/box';
import { LazyMedia } from '@/features/news-managment/ui/lazy-media';
import { resolveMediaPath } from '@/shared/libs/resolve-media-path';
import { BodyTextRegularPrimary } from '@/shared/ui/typography';
import { Button } from '@/shared/ui/form/button';

export const BannerItem = ({
  banner,
  handleClick,
  mobileLandscape,
  router,
}) => {
  return (
    <SlideContent onClick={() => handleClick(banner?.link)} $type="promo">
      <Box
        $position="absolute"
        $top="0"
        $left="0"
        $width="100%"
        $height="100%"
        $zIndex="-1"
      >
        <LazyMedia
          videoSrc={banner?.video ? resolveMediaPath(banner.video) : null}
          imageSrc={resolveMediaPath(banner?.image)}
          alt={banner?.header || 'Banner'}
          mobileLandscape={mobileLandscape}
        />
      </Box>

      <Box
        $fill
        $display="flex"
        $flexDirection="column"
        $textAlign="left"
        $justifyContent="space-between"
      >
        <Box>
          <BoldHeadingQuinaryDynamic>
            {banner?.header || (
              <Box $visibility="hidden" $paddingBottom="12px" />
            )}
          </BoldHeadingQuinaryDynamic>
          <BodyTextRegularPrimary
            style={{
              fontSize: mobileLandscape ? '14px' : '15px',
              width: '140px',
            }}
          >
            {banner?.text}
          </BodyTextRegularPrimary>
        </Box>
        <Box $textAlign={['left', 'center']} $paddingBottom={[0, '16px']}>
          <Button
            style={{ fontWeight: 500 }}
            variant="yellow"
            onClick={() => router.push(banner?.link)}
          >
            <Box $padding={mobileLandscape ? '4px 16px' : '0 16px'}>
              {banner?.btnTitle}
            </Box>
          </Button>
        </Box>
      </Box>
    </SlideContent>
  );
};
